var animations = {
	// variable: 'value' .... can get sile this self.variable
	vars: {
		selector: '[animate-this]',
	},
	init: function () {
		var self = this;

		const elements = document.querySelectorAll(self.vars.selector);

		if (elements.length < 1) {
			return;
		}

		if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
			elements.forEach((entry) => {
				self.animateElements(entry.target);
			});

			return;
		}

		const config = {
			root: null,
			rootMargin: '0px',
			threshold: 0.1,
		};

		let observer = new IntersectionObserver(function (entries, myself) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					self.animateElements(entry.target);
					myself.unobserve(entry.target); // Stop watching
				}
			});
		}, config);

		elements.forEach((element) => {
			observer.observe(element);
		});
	},
	animateElements: function (target) {
		target.classList.add('loaded');
	},
};

export { animations };
